import { Row, Col, Form, Button, Tab, Table, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Css from './Customer.module.css';
import ApiConection from 'api_ref/ApiConection';
import { useEffect, useState } from "react";
import { AddCommar, ConvertDateTimeToText, DisplayPaging } from "components/MyControl";
import Layout4Admin1 from "components/layout/Layout4Admin1";
import AdminTable from "./AdminTable";
import Footer4Bottom1 from "components/layout/Foot4Bottom1";

export default function AccountWaitCheckPayment() {
    const navigate = useNavigate();

    const api = new ApiConection();

    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [condition, setCondition] = useState({
    });
    const [pagination, setPagination] = useState({
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    })
    const [search, setSearch] = useState({
        page: 1,
        size: 10
    })
    const [filterDispaly, setFilterDisplay] = useState(false);

    const getQuontation = async () => {
        let data = {
            search: {
                //payment_status_id:3,
                audit_status_id: 2
            },
            pagination: {
                size: search.size,
                page: search.page,
                order_by: "quontation_number",
                order_mode: "desc"
            }
        }

        if (condition.company_name != '')
            data.search.company_name = condition.company_name;

        // let data = {
        //     search: condition,
        //     pagination: {
        //         size: search.size,
        //         page: search.page,
        //         orderby:"QuontationNumber",
        //         ordermode:"desc"
        //     }
        // }

        setLoading(true);

        const response_paging = await api.postData(`api/quontation/pagination`, data);
        if (response_paging.status === true) {
            handleSetPagination('record_start', response_paging.data.record_start);
            handleSetPagination('record_count', response_paging.data.record_count);
            handleSetPagination('page_count', response_paging.data.page_count);

            let record_end = response_paging.data.record_start + (search.size - 1);
            if (record_end > response_paging.data.record_count) {
                record_end = response_paging.data.record_count;
            }

            handleSetPagination('record_end', record_end);
        }

        const response = await api.postData(`api/quontation/result`, data);
        setDataList(response.data);
        //console.log(response.data);
        setLoading(false);
    }

    const handleQuickSearch = (event) => {
        const { name, value } = event.target;
        handleSetCondition('company_name', value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleSetCondition = (name, value) => {
        setCondition(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetPagination = (name, value) => {
        setPagination(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;
        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }
    const handlePagingChange = (page_no) => {
        handleSetSearch('page', page_no);
    }

    const handleOpenDetail = (quontation_id) => {
        navigate(`/paytransaction/${quontation_id}/detail`);
    }

    useEffect(() => {
        getQuontation();
    }, [])

    useEffect(() => {
        if (search !== undefined) {
            const delay = setTimeout(() => {
                // เรียกใช้ฟังก์ชันสำหรับการคำนวณผลลัพธ์ที่ต้องการ
                getQuontation();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [search, condition])

    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box + ' shadow'}>
                        <div className={Css.Content}>
                            <div className={Css.Header}>
                                <div className="d-flex">
                                    <h6 className="d-flex align-items-center">รายการรอตรวจสอบ</h6>
                                    <div className="flex-fill">
                                        <Form.Group as={Row}>
                                            <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                                            <Col>
                                                <InputGroup>
                                                    <Form.Control placeholder="บริษัท" id={'company_name'} value={condition.company_name}
                                                        disabled={filterDispaly}
                                                        onChange={(event) => handleQuickSearch(event)} />
                                                    <Button variant="outline-secondary" onClick={event => setFilterDisplay(!filterDispaly)}>
                                                        {
                                                            filterDispaly === true &&
                                                            <i className="fa-solid fa-arrow-up-short-wide"></i>
                                                        }
                                                        {
                                                            filterDispaly === false &&
                                                            <i className="fa-solid fa-arrow-down-short-wide"></i>
                                                        }
                                                        <span></span>
                                                    </Button>
                                                    <Button>
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </Button>
                                                </InputGroup>

                                            </Col>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                            <div className="position-relative" >
                                {
                                    loading &&
                                    <div className="position-absolute w-100 h-100 bg-white bg-opacity-50" style={{ zIndex: 5 }}>
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <AdminTable path={"/account/waiting-check-payment/"} title={"รายการรอตรวจสอบ"} dataList={dataList} />

                                <DisplayPaging rec_start={pagination.record_start}
                                    rec_end={pagination.record_end}
                                    rec_count={pagination.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={pagination.page_count}
                                    onPagingChange={handlePagingChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Admin1>
    )
}